(() => {
  if (window.madeInCollectionFiltersReady) return;
  window.madeInCollectionFiltersReady = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-mi-filter-link], a[data-mi-clear-filters], a.mi-category-chip');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const current = new URL(location.href);
    const next = new URL(link.href);
    if (next.origin !== current.origin) return;
    if (link.hasAttribute('data-mi-filter-link')) {
      // Tag paths filter across groups with AND. Native price/stock filters and sorting remain selected.
      for (const key of new Set(current.searchParams.keys())) {
        if (key.startsWith('filter.') || key === 'sort_by') {
          next.searchParams.delete(key);
          for (const value of current.searchParams.getAll(key)) next.searchParams.append(key, value);
        }
      }
    }
    const preview = current.searchParams.get('preview_theme_id');
    if (preview) next.searchParams.set('preview_theme_id', preview);
    next.searchParams.delete('page');
    if (next.href !== link.href) {
      event.preventDefault();
      location.assign(next.href);
    }
  });

  // Native facets use pushState; Back/Forward must restore the matching server results too.
  window.addEventListener('popstate', () => {
    if (document.querySelector('.mi-collection-products')) location.reload();
  });

  const syncCount = () => {
    const form = document.querySelector('.mi-collection-products facets-form-component[data-results-count]');
    const heading = document.querySelector('.mi-collection-heading__count');
    if (form && heading) heading.textContent = `${form.dataset.resultsCount} منتج`;
  };
  const init = () => {
    const results = document.querySelector('.mi-collection-products');
    if (!results) return;
    syncCount();
    new MutationObserver(syncCount).observe(results, { subtree: true, attributes: true, attributeFilter: ['data-results-count'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
